import React, { useState } from "react";

import { getAdminVerificationYearlyDataYear, useTranslation } from "utils";

import { Col, Drawer, ExtraInfo, Icon, LinkMoreInfo, PageSpin, Row, TaskCard } from "components";

import { ContactSupport } from "pages/app/farm/components/ContactSupport";
import { SubmitTaskDrawer } from "pages/app/farm/components/SubmitTaskDrawer";

export const TaskOverviewDrawer = ({ farmTasks, visible, onClose, onDataChange, loading }) => {
  const { t } = useTranslation("tasks");

  const [showInfoDrawer, setShowInfoDrawer] = useState(false);

  const [showSubmitTaskDrawer, setShowSubmitTaskDrawer] = useState(false);
  const [selectedFarmTask, setSelectedFarmTask] = useState(null);

  const currentVerificationYear = getAdminVerificationYearlyDataYear();

  const handleCardClick = (farmTask) => {
    setSelectedFarmTask(farmTask);
    setShowSubmitTaskDrawer(true);
  };

  const handleSubmitTaskDrawerClose = () => {
    setSelectedFarmTask(null);
    setShowSubmitTaskDrawer(false);
  };

  const NoTasksToShow = () => (
    <Row>
      <Col className="center">
        <Icon iconName="tabler/mood-smile" className="icon inline" color="black" size="xxl" />
        <p className="h3">{t("submitTaskDrawer.noTasks")}</p>
      </Col>
    </Row>
  );

  const TaskList = () =>
    farmTasks.map((farmTask, i) => (
      <Row key={i}>
        <Col>
          <Row>
            <Col>
              <TaskCard
                completed={!!farmTask.completedAt}
                documentName={farmTask.task?.documentName}
                year={farmTask.year}
                deadline={farmTask.deadline}
                onClick={!farmTask.completedAt ? () => handleCardClick(farmTask) : null}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    ));

  return (
    <Drawer dataTestId="task-overview-drawer" title={t("taskOverviewDrawer.title")} visible={visible} onClose={onClose}>
      <Row className="margin-bottom-350">
        <Col>
          <h1>{t("taskOverviewDrawer.headline", { year: currentVerificationYear })}</h1>
          <p>{t("taskOverviewDrawer.description")}</p>
          <LinkMoreInfo onClick={() => setShowInfoDrawer(true)}>{t("taskOverviewDrawer.infoLink")}</LinkMoreInfo>
        </Col>
      </Row>

      {/* Right now this component will only be shown if there are farm tasks so we can use the length of the array as loading state */}
      {loading ? (
        <PageSpin fullHeight={false} />
      ) : !farmTasks.length ? (
        <NoTasksToShow />
      ) : (
        <>
          <TaskList />

          <Row className="margin-top-300 margin-bottom-200">
            <Col>
              <ContactSupport />
            </Col>
          </Row>
        </>
      )}

      <ExtraInfo setVisible={setShowInfoDrawer} type="verification-tasks" visible={showInfoDrawer} />
      <SubmitTaskDrawer farmTask={selectedFarmTask} visible={showSubmitTaskDrawer} onClose={handleSubmitTaskDrawerClose} onFinish={onDataChange} />
    </Drawer>
  );
};

export default TaskOverviewDrawer;
